import { render, staticRenderFns } from "./smartLifeIndex.vue?vue&type=template&id=544738c9&scoped=true"
import script from "./smartLifeIndex.vue?vue&type=script&lang=js"
export * from "./smartLifeIndex.vue?vue&type=script&lang=js"
import style0 from "./smartLifeIndex.vue?vue&type=style&index=0&id=544738c9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544738c9",
  null
  
)

export default component.exports